import type { ReactNode } from "react";
import { useLocale } from "../i18n/provider.js";

/**
 * **علامةُ مِنوال وتوقيعُه — هويّةُ TWING، لا هويّةُ المشتري.**
 *
 * فمِنوال يُنصَّب عند كلّ وكالةٍ ويُلوَّن بلونها وحدها: **أيقونةُ التطبيق
 * ولونُه للمشتري** (بيعٌ بلا علامةٍ بائعة). أمّا هذه العلامةُ فلـ TWING: تظهر في
 * تنصيب TWING نفسِه، **وفي التوقيع «منوال من TWING»** على شاشة الدخول وما شابهها.
 * وهو نصُّ وثيقة الهوية المعتمدة (٢٠٢٦-١٠-٢٠).
 *
 * **والعلامةُ لا تُعاد رسماً ولا تُلوَّن بغير نسختيها** — فهما ملفّان كما سُلِّما،
 * والوضعُ الليليُّ يختار بينهما بالأنماط، لا بحسابٍ في المتصفّح.
 */
export function MinwalMark({ size = 28 }: { readonly size?: number }): ReactNode {
  return (
    <span className="mw-mark" aria-hidden="true">
      <img
        className="mw-light"
        src="/brand/minwal-mark-light.svg"
        alt=""
        width={size}
        height={size}
      />
      <img
        className="mw-dark"
        src="/brand/minwal-mark-dark.svg"
        alt=""
        width={size}
        height={size}
      />
    </span>
  );
}

/** **التوقيعُ** — «منوال من TWING» بالعلامة، أسفلَ شاشة الدخول */
export function MinwalCredit(): ReactNode {
  const { t } = useLocale();
  return (
    <p className="mw-credit">
      <MinwalMark size={18} />
      <span>{t("brand.credit")}</span>
    </p>
  );
}
